import axiosInstance from "../axiosInstance";

export const catalogPlanManagementService = {
  /** Update the status (active|draft) of a single category within a plan */
  updateCategoryStatus: async (planId, categoryId, status) => {
    try {
      const response = await axiosInstance.patch(
        `/catalog-plan-management/${planId}`,
        { category_id: categoryId, status },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /** The plan's SKU shares (optionally one row): { computed_at, shares: [{ sku, row_key, share, list_price, … }] } */
  skuShares: async (planId, rowKey) => {
    const params = [`plan_id=${encodeURIComponent(planId)}`];
    if (rowKey) params.push(`row_key=${encodeURIComponent(rowKey)}`);
    const response = await axiosInstance.get(
      `/catalog-plan-management?${params.join("&")}`,
    );
    return response.data;
  },
};
